import { useState } from "react";
import SectionHeader from "shared/components/Header/SectionHeader";
import styles from "./Collaborate.module.css";
import { FaArrowUpRightFromSquare } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import { trackCtaClick } from "shared/services/analytics";

const Collaborate = () => {
  const [isHovered, setIsHovered] = useState(false);

  const navigate = useNavigate();

  const handleClick = () => {
    trackCtaClick("collaborate");
    navigate("/contact");
  };

  return (
    <div
      className={styles.container}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <button
        type="button"
        className={styles.content}
        onClick={handleClick}
        onFocus={() => setIsHovered(true)}
        onBlur={() => setIsHovered(false)}
      >
        <SectionHeader title="Let's Collaborate" invert={isHovered} />
        <p className={styles.description}>
          Unlock the potential of your product with expert design and
          development services. Let's collaborate to create user-centered
          solutions that not only meet your goals but also delight your users.
        </p>
        <div className={styles.iconWrapper}>
          <FaArrowUpRightFromSquare className={styles.icon} />
        </div>
      </button>
    </div>
  );
};

export default Collaborate;
